module.exports = __webpack_public_path__ + "static/media/day-passed-icon.3bbe26ec.png";